import React from 'react';
import {
    StyleSheet,
    View,
    TouchableOpacity,
    ScrollView,
    TouchableWithoutFeedback,
    ActivityIndicator,
    Platform
  } from 'react-native'
import css from './Style'
import MyText from './MyText';
import MyDatePicker from './MyDatePicker';
import MyTextInput from './MyTextInput';
import { MaterialIcons, Entypo, Feather } from '@expo/vector-icons'; 
import * as SecureStore from 'expo-secure-store';
import axios from 'axios';
import PRF from './assets/icons/PRF.svg';
import IndustrialWaste from './assets/icons/IndustrialWaste.svg';
import MySVG from './assets/MySVG';

import { connect } from 'react-redux';
import { openModal, closeModal } from './modalActions';
import AsyncStorage from '@react-native-async-storage/async-storage';

const Login = (props) => {

    const [type, setType] = React.useState('PRF');
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');

    const Login = async() => {
        const data = {
            email,
            password,
            uuid: await AsyncStorage.getItem('uuid')
        };
        console.log(data);
        axios.post('/api/user/login.php', data)
        .then(async(res) => {
            props.setUser(res.data);
            await AsyncStorage.setItem('token', res.data.token);
            if(!res.data.isVGroup){
                setTimeout(() => {
                    props.navigation.reset({
                        index: 1,
                        routes: [{ name: 'My Requests' }],
                    });  
                },100)
            }
            else{
                console.log('vgroup');
                setTimeout(() => {
                    props.navigation.reset({
                        index: 1,
                        routes: [{ name: 'Manage Requests' }],
                    });  
                },100)
            }
        })
        .catch((err) => {
            if(err.response?.status == 401){
                props.openModal('Warning', err.response.data);
            }
            else{
                props.openModal('Warning', 'An internal error occured. Please try again later or contact us.');
            }
        })
    }

  return (
    <View style={{alignItems: 'center', justifyContent: 'center', marginTop: Platform.OS==='web'?24:15, marginBottom: Platform.OS==='web'?25:0}}>
        <View style={{width: 232}}>
            <MyText style={[css.title, css.bold]}>
                Login
            </MyText>
            <View style={{marginTop: 12, flexDirection: 'row'}}>
                <MyTextInput
                    style={[{flexGrow: 0, flexShrink: 0, flexBasis: 232}, css.formRowInput]}
                    onChangeText={setEmail}
                    value={email}
                    inputMode='email'
                    keyboardType='email-address'
                    autoCapitalize='none'
                    autoCorrect={false}
                    placeholder='Email'
                    fancyPlaceholder={true}
                    validation='email'
                />
            </View>
            <View style={{marginTop: 12, flexDirection: 'row'}}>
                <MyTextInput
                    style={[{flexGrow: 0, flexShrink: 0, flexBasis: 232}, css.formRowInput]}
                    onChangeText={setPassword}
                    value={password}
                    secureTextEntry={true}
                    placeholder='Password'
                    fancyPlaceholder={true}
                    autoCapitalize='none'
                    autoCorrect={false}
                />
            </View>
            <View style={{marginTop: 12, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                <TouchableOpacity onPress={() => Login()} style={{flexGrow: 0, flexShrink: 0, flexBasis: 110, marginRight: 10}}>
                    <MyText style={[css.button, css.bold]}>
                        Login
                    </MyText>
                </TouchableOpacity>
                <TouchableOpacity style={{flexGrow: 0, flexShrink: 0}}>
                    <MyText style={[css.bold, css.xs, {color: '#461b6f'}]}>
                        Forgot Password?
                    </MyText>
                </TouchableOpacity>
            </View>
            <View style={{marginTop: 15, alignItems: 'center'}}>
                <TouchableOpacity onPress={() => props.navigation.push('Register')} style={{flexGrow: 0, flexShrink: 0}}>
                    {/* <View style={{borderStyle: Platform.OS==='ios'?'solid':'dotted', borderColor: '#461b6f', borderBottomWidth: 1}}> */}
                        {/* <MyText style={[css.bold, {fontSize: 10, color: '#461b6f', paddingBottom: 3}]}>
                            Register and Join Us!
                        </MyText> */}
                    {/* </View> */}
                    <View style={{ overflow: 'hidden' }}>
                        <View
                        style={{
                            borderStyle: 'dashed',
                            borderWidth: 1,
                            borderColor: '#461b6f',
                            margin: -2,
                            marginBottom: 10,
                            paddingHorizontal: 1
                        }}>
                        {/* https://stackoverflow.com/questions/73506925/when-trying-to-add-a-dashed-border-style-getting-unsupported-dashed-dotted-b */}
                        <MyText style={[css.bold, css.s, {color: '#461b6f', paddingBottom: 3, textAlign: 'center'}]}>
                            Register and Join Us!
                        </MyText>
                        {/* <View style={{ height: 1, width: 200 }} /> */}
                        </View>
                    </View>
                </TouchableOpacity>
            </View>
        </View>
    </View>
  );
}

const styles = StyleSheet.create({

});

const mapDispatchToProps = {
    openModal,
    closeModal,
}

export default connect(null, mapDispatchToProps)(Login)